import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { AssetService } from 'src/app/core/services/http/agency-mgmt/asset.service';
import { TosterService } from 'src/app/core/services/toster/toster.service';

@Component({
  selector: 'app-sent-to-tenant-asset',
  templateUrl: './sent-to-tenant-asset.component.html',
  styleUrls: ['./sent-to-tenant-asset.component.scss']
})
export class SentToTenantAssetComponent implements OnInit {
  showData: any;
  public isLoading : boolean

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: {},
    private bottomsheet: MatBottomSheetRef<SentToTenantAssetComponent>,
    private assetService: AssetService,
    private tosterService: TosterService) { }

  ngOnInit(): void {
    this.showData = this.data;
  }

  sentToTenantAsset() {
    this.isLoading = true;
    this.assetService.sentToTenantAsset(this.data["assetId"]).subscribe({
      next: (res) => {
        this.tosterService.success("successfully send!");
        this.isLoading = false;
        this.bottomsheet.dismiss(true);
      },
      error: (err) => {
        this.isLoading = false;
      }
    });
  }

  cancel() {
    this.bottomsheet.dismiss();
  }
}
